import { useUploadProfileAvatarMutation } from '@common/cache';
import { dataURItoBlob } from '@util/image-utils';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { formatApiError } from '@common/errors/error-formatting.ts';

interface IUseUploadAvatarModalProps {
  onClose: () => void;
}

export const useUploadAvatarModal = ({
  onClose,
}: IUseUploadAvatarModalProps) => {
  const uploadAvatarMutation = useUploadProfileAvatarMutation();
  const [logo, setLogo] = useState<string>('');

  const handleLoadLogo = async (newLogo: string) => {
    setLogo(newLogo);
  };

  const handleUnloadLogo = async () => {
    setLogo('');
  };

  const [loading, setLoading] = useState(false);

  const handleSave = async () => {
    let blob = dataURItoBlob(logo);
    let fd = new FormData();
    fd.append('file', blob);

    if (logo) {
      try {
        setLoading(true);

        toast.info('Avatar uploading...');

        await uploadAvatarMutation.mutateAsync({
          file: fd,
        });
        toast.success('Avatar updated');

        setLoading(false);
        onClose();
      } catch (error) {
        toast.error(formatApiError(error));
      } finally {
        setLoading(false);
      }
    }
  };
  return {
    logo,
    handleLoadLogo,
    handleUnloadLogo,
    loading,
    handleSave,
  };
};
